export default __webpack_public_path__ + "static/media/fig25.70bc1abf.png";